__turbopack_context__.v({
  "offerTileBreakpointStyles": "g0JGGq_offerTileBreakpointStyles",
  "offerTileButtonsContainer": "g0JGGq_offerTileButtonsContainer",
  "offerTileButtonsContainerInline": "g0JGGq_offerTileButtonsContainerInline",
  "offerTileContainer": "g0JGGq_offerTileContainer",
  "offerTileLinkContainer": "g0JGGq_offerTileLinkContainer",
  "offerTileOriginalPrice": "g0JGGq_offerTileOriginalPrice",
  "offerTilePrice": "g0JGGq_offerTilePrice",
  "offerTilePriceContainer": "g0JGGq_offerTilePriceContainer",
  "offerTileRow": "g0JGGq_offerTileRow",
  "offerTileText": "g0JGGq_offerTileText",
  "offerTileTextContainer": "g0JGGq_offerTileTextContainer",
  "offerTileTitle": "g0JGGq_offerTileTitle",
  "purchaseableOfferTileText": "g0JGGq_purchaseableOfferTileText",
  "purchaseableOfferTitle": "g0JGGq_purchaseableOfferTitle",
  "rejectedOfferTitle": "g0JGGq_rejectedOfferTitle",
});
